import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import NotFoundView from '@/views/NotFoundView.vue'
import { settingsService } from '@/services/settingsService'
import { useClientStore } from '@/stores/client'

// Route guard to check if portfolio category is enabled
const portfolioGuard = (to: any) => {
  const category = to.path.split('/')[2] // Extract category from /portfolio/category
  const categoryMap: { [key: string]: string } = {
    'weddings': 'weddings',
    'bridal': 'bridal',
    'seniors': 'seniors', 
    'graduation': 'graduation',
    'headshots': 'headshots',
    'maternity': 'maternity',
    'creative': 'creative',
    'fashion': 'fashion',
    'modeling': 'modeling'
  }
  
  const settingsCategory = categoryMap[category]
  if (settingsCategory && !settingsService.isCategoryEnabled(settingsCategory)) {
    return '/404'
  }
  return true
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/AboutView.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/views/ContactView.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue')
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('@/views/ResetPasswordView.vue')
    },
    {
      path: '/share/:token',
      name: 'share-gallery',
      component: () => import('@/views/ShareGalleryView.vue')
    },
    {
      path: '/portfolio/modeling',
      name: 'model-portfolio',
      component: () => import('@/views/ModelPortfolioView.vue'),
      beforeEnter: portfolioGuard
    },
    {
      path: '/portfolio/weddings',
      name: 'wedding-portfolio',
      component: () => import('@/views/WeddingPortfolioView.vue'),
      beforeEnter: portfolioGuard
    },
    {
      path: '/portfolio/bridal',
      name: 'bridal-portfolio',
      component: () => import('@/views/BridalPortfolioView.vue'),
      beforeEnter: portfolioGuard
    },
    {
      path: '/portfolio/seniors',
      name: 'seniors-portfolio',
      component: () => import('@/views/SeniorPortfolioView.vue'),
      beforeEnter: portfolioGuard
    },
    {
      path: '/portfolio/graduation',
      name: 'graduation-portfolio',
      component: () => import('@/views/GraduationPortfolioView.vue'),
      beforeEnter: portfolioGuard
    },
    {
      path: '/portfolio/headshots',
      name: 'headshots-portfolio',
      component: () => import('@/views/HeadshotPortfolioView.vue'),
      beforeEnter: portfolioGuard
    },
    {
      path: '/portfolio/maternity',
      name: 'maternity-portfolio',
      component: () => import('@/views/MaternityPortfolioView.vue'),
      beforeEnter: portfolioGuard
    },
    {
      path: '/portfolio/creative',
      name: 'creative-portfolio',
      component: () => import('@/views/CreativePortfolioView.vue'),
      beforeEnter: portfolioGuard
    },
    {
      path: '/portfolio/fashion',
      name: 'fashion-portfolio',
      component: () => import('@/views/FashionPortfolioView.vue'),
      beforeEnter: portfolioGuard
    },
    {
      path: '/portfolio/models',
      name: 'models-portfolio',
      component: () => import('@/views/ModelPortfolioView.vue'),
      beforeEnter: portfolioGuard
    },
    {
      path: '/client/dashboard',
      name: 'client-dashboard',
      component: () => import('@/views/ClientDashboard.vue'),
      meta: { requiresClientAuth: true }
    },
    {
      path: '/client/gallery/:id',
      name: 'client-gallery',
      component: () => import('@/views/ClientGallery.vue'),
      meta: { requiresClientAuth: true }
    },
    {
      path: '/404',
      name: 'not-found',
      component: NotFoundView
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/404'
    }
  ]
})

// Global route guard for client authentication
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresClientAuth) {
    const clientStore = useClientStore()
    const isAuthenticated = await clientStore.verifyAuth()
    
    if (!isAuthenticated) {
      next('/login')
      return
    }
  }
  next()
})

export default router
